module.exports = __webpack_public_path__ + "img/logo.452e9bb4.png";